"use client";
import { fetchAPI } from "@/utils/fetchApi";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import VideoCard from "@/components/VideoCard/VideoCard";
import CustomCarousel from "@/components/CustomCarousel/CustomCarousel.js";
import { useState, useEffect } from "react";

export const dynamic = "force-static";

export default function PartnerVideos() {
  const [videos, setVideos] = useState([]);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await fetchAPI("become-partner?populate=relatedVideos");
        const fetchedVideos = response?.data?.relatedVideos?.data ||
                            response?.data?.relatedVideos ||
                            response?.data?.attributes?.relatedVideos?.data ||
                            [];
        setVideos(fetchedVideos);
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const getItemsPerPage = () => {
    if (typeof window === "undefined") return 1;
    if (window.innerWidth < 640) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <BreadCrumbs />
      <section className="py-10 sm:py-14 md:py-16">
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <h1 className="font-poppins text-[32px] leading-none tracking-wider text-center mb-8">
            <span className="font-[275]">Success Stories from Our </span>
            <span className="text-[#006DAF] font-normal">Partners</span>
          </h1>

          {videos && videos.length > 0 ? (
            <CustomCarousel
              itemsPerPage={getItemsPerPage()}
              className="md:px-0 -mx-4"
            >
              {videos.map((video) => (
                <div
                  key={video.id}
                  className="w-[320px] h-[190.9px] ml-5 mr-auto md:mx-auto md:w-[420px] md:h-[249px]"
                >
                  <div className="w-full h-full">
                    <VideoCard
                      video={video}
                      isActive={activeVideoId === video.id}
                      onPlay={() => setActiveVideoId(video.id)}
                      className="w-full h-full"
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "0.77px solid #e5e7eb"
                      }}
                    />
                  </div>
                </div>
              ))}
            </CustomCarousel>
          ) : (
            <div className="text-center py-8 text-gray-600">No videos found</div>
          )}
        </div>
      </section>
    </div>
  );
}